import { Component, OnChanges, Input } from '@angular/core';

@Component({
  selector: 'app-section-cumplimiento',
  templateUrl: './section-cumplimiento.component.html',
  styleUrls: ['./section-cumplimiento.component.css']
})
export class SectionCumplimientoComponent implements OnChanges {

  @Input() public dataCumplimiento : string[] = [];
  public objetoSectionCumplimiento : SectionCumplimiento = {
    visual : "",
    auditiva : "",
    respiratoria : "",
    osteomuscular : "",
    cardiovascular : "",
    otra : ""
  };

  constructor() { }

  ngOnChanges() {
    this.getDataCumplimiento();
  }

  private async getDataCumplimiento() {
    try {
      await this.dataCumplimiento;
      this.objetoSectionCumplimiento = {
        visual : "",
        auditiva : "",
        respiratoria : "",
        osteomuscular : "",
        cardiovascular : "",
        otra : ""
      };

      if( this.dataCumplimiento != null ) {

        for(let i = 0; i < this.dataCumplimiento.length; i++) {
          switch ( this.dataCumplimiento[i] ) {
            case "Visual":
            this.objetoSectionCumplimiento.visual = this.dataCumplimiento[i];
              break;
            case "Auditiva":
            this.objetoSectionCumplimiento.auditiva = this.dataCumplimiento[i];
              break;
            case "Respiratoria":
            this.objetoSectionCumplimiento.respiratoria = this.dataCumplimiento[i];
              break;
            case "Osteomuscular":
            this.objetoSectionCumplimiento.osteomuscular = this.dataCumplimiento[i];
              break;
            case "Cardiovascular":
            this.objetoSectionCumplimiento.cardiovascular = this.dataCumplimiento[i];
              break;
            default:
            this.objetoSectionCumplimiento.otra = this.dataCumplimiento[i];
              break;
          }
        }

      }

    }catch(exception) {
      console.log(exception);
    }
  }

}

interface SectionCumplimiento {
  visual : string,
  auditiva : string,
  respiratoria : string,
  osteomuscular : string,
  cardiovascular : string,
  otra : string
}